import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as _ from 'underscore';

import styles from './_styles/DdnyResults.module.scss';

import ResultsControls from './blocks/ResultsControls';
import ResultsGallery from './blocks/ResultsGallery';
import ResultsPagination from './blocks/ResultsPagination';

import * as ddnyActionCreators from '../../../actions/ddny';
const allActionCreators = Object.assign({}, ddnyActionCreators);

export class DdnyResults extends Component {

	constructor(props) {
		
		super(props);

		this.state = {
			requestPending: false,
			requestResults: null,
			requestCount: null,

			pageNumber: this.props.ddny?.filters?.page || 1,
			pageSize: 60,
			pageSort: null,
		};

		this.controller = null;
	}

	componentDidMount() {
		this.fetchProductPage();
	}

	componentDidUpdate(prevProps, prevState) {
		if(prevProps?.ddny?.filters && this.props?.ddny?.filters && !_.isEqual(prevProps.ddny.filters, this.props.ddny.filters)) {
			this.fetchProductPage();
		}
	}

	componentWillUnmount() {
		if(this.controller) {
			this.controller.abort();
		}
	}

	async fetchProductPage() {

		if(this.controller) {
			this.controller.abort();
		}
		const controller = new AbortController();
		this.controller = controller;
	
		this.setState({
			requestPending: true,
		});

		try {

			const pageControls = {
				page: this.state.pageNumber,
				size: this.state.pageSize,
			};

			if(this.state.pageSort) {
				pageControls['sort'] = this.state.pageSort;
			}

			const requestData = Object.assign({}, this.props.ddny.filters, pageControls);

			const pageData = await this.props.ddnyFetchProductPage(requestData, controller.signal);

			this.setState({
				requestResults: pageData.data,
				requestCount: pageData.count,
			});

		} catch(err) {
			console.error(err);
			this.setState({
				requestResults: [],
				requestCount: null,
			})
		} finally {
			this.setState({
				requestPending: false,
			});
		}
	}

	setSort(sortVal) {
		if(sortVal !== this.state.pageSort) {
			this.setState({ pageSort: sortVal }, () => {
				this.fetchProductPage();
			});
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
	}

	setPage(pageVal) {
		if(pageVal !== this.state.pageNumber) {
			this.setState({ pageNumber: parseInt(pageVal) || 1 }, () => {
				this.props.ddnySetFilters({
					...this.props.ddny.filters,
					page: this.state.pageNumber,
					size: this.state.pageSize,
				});
				this.fetchProductPage();
			});
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
	}
	
	render() {
		return <div className={styles.DdnyResults}>
			<div className={styles.controllsWrapper}>
				<ResultsControls
					dataCount={this.state.requestCount}
					currentPage={this.state.pageNumber}
					currentPageSize={this.state.pageSize}
					setPage={this.setPage.bind(this)}
					setSort={this.setSort.bind(this)} />
			</div>
			<div className={styles.galleryWrapper}>
				<ResultsGallery
					dataResults={this.state.requestResults}
					dataCount={this.state.requestCount}
					dataPending={this.state.requestPending} />
			</div>
			<div className={styles.paginationWrapper}>
				<ResultsPagination
					dataCount={this.state.requestCount}
					currentPage={this.state.pageNumber}
					currentPageSize={this.state.pageSize}
					setPage={this.setPage.bind(this)} />
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {
		ddny: state.ddny,
	};
}

export default connect(mapStateToProps, allActionCreators)(DdnyResults);